/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ee7ce81e8df4a1f59d4c8b8e9d8dcd2c568fb299";
